<template>
  <div class="row container-fluid flex-grow-1 overflow-hidden" style="height: 100vh;" >
    <!-- MASTER PANE -->
    <div class="col-6 col-lg-5 mh-100 overflow-auto div-master">
      <!-- ORDER LIST -->
      <PosOrderList :shop-id="shopId" :orders="orders" :is-loading="isLoading"
        :sort="shop.settings.sort" :search="search.keyword"
        @select="onOrderSelected" @toggle-toolbar="toggleToolbar"/>
    </div>

    <!-- DETAIL PANE -->
    <div class="col-6 col-lg-7 mh-100 overflow-auto div-detail">
      <!-- <PosOrderDetail :shop-id="shopId" :order-id="selectedOrderId" :is-pub="isPub"/> -->
      <PosOrderDetail :shop-id="shopId" :current="selectedOrder" :is-pub="isPub"/>
    </div>

    <!-- TOP DRAWER - TOOLBAR -->
    <el-drawer :visible.sync="toolbar.show" direction="ttb" :show-close="true"
      style="height: auto;">
      <div slot="title" class="row d-flex align-items-center">
        <div class="col-4">
          <img :src="logoPath" class="img-fluid pl-5" alt="Gt-logo">
        </div>
        <div class="col-3">
          <span style="font-size: large;">{{user.shopName}}</span>
        </div>
        <div class="col-5 pr-5 d-flex align-items-center justify-content-end">
          <el-input placeholder="搜尋流水號" v-model="search.keyword" type="number"
            style="width: 160px; margin-right: 12px;" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-button type="info" circle icon="el-icon-s-tools"
            @click="openSettings"></el-button>
          <el-button type="default" circle icon="el-icon-switch-button"
            @click="logout"></el-button>
        </div>
      </div>
    </el-drawer>

    <!-- SETTINGS DIALOG -->
    <el-dialog title="選項" :visible.sync="settingsDialog.show" @closed="commitSettings">
      <el-form label-position="right" label-width="160px" :model="shop.settings">
        <el-form-item label="訂單日期範圍">
          <el-select v-model="shop.settings.duration" placeholder="（顯示範圍）" size="mini">
            <el-option v-for="opt in settingsDialog.durationOptions"
              :key="opt.value" :label="opt.label" :value="opt.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="排序依">
          <el-select v-model="shop.settings.sort" placeholder="（排序方法）" size="mini">
            <el-option v-for="opt in settingsDialog.sortOptions"
              :key="opt.value" :label="opt.label" :value="opt.value">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="未完成提醒間隔">
          <el-select v-model="shop.settings.reminder" placeholder="（未完成提醒間隔）" size="mini">
            <el-option v-for="opt in settingsDialog.reminderOptions"
              :key="opt.value" :label="opt.label" :value="opt.value">
            </el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="新進單提示音">
          <!-- <el-checkbox v-model="shop.settings.soundEnabled">開啟？</el-checkbox> -->
          <el-switch v-model="shop.settings.soundEnabled" active-text="開啟" inactive-text="關閉"></el-switch>
        </el-form-item>
  
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { fsdb } from '../../firestore';
import PosOrderList from './PosOrderList';
import PosOrderDetail from './PosOrderDetail';

import axios from 'axios';
import moment from 'moment';
import { setTimeout } from 'timers';

let chime;

export default {
  components: {
    PosOrderList, PosOrderDetail
  },

  mounted() {
    //FIXME: THIS IS FOR APTG FOR TEST ONLY!! REMOVE THIS IN PRODUCTION!!
    if (this.$router.currentRoute.path === '/pub/qcpos') {
      this.shopId = parseInt(this.$route.query.shopId || '140');
      this.isPub = true;
      return;
    }
    // I forgot what does this mean...
    else {
      console.log(`[QC-POS] QC-POS user info`, this.user);
      if (!this.user || !this.user.shopId) {
        this.$router.push('/qcpos/login');
        return;
      }
      this.shopId = this.user.shopId;
      this.isPub = false;
    }

    // Turn on periodical reminder after a while (5-min in default).
    // this.enableReminder();

    //FIXME: Workaround for playing sound in Safari.
    document.body.addEventListener('touchstart', this.soundStarter, false);
    document.body.addEventListener('mousedown', this.soundStarter, false);

    //NOTE: Use a confirm dialog to force user to tap at least once before entering.
    this.$confirm('', '歡迎使用 POS 接單介面！', {
      confirmButtonText: '點此開始',
      showClose: false,
      showCancelButton: false,
      roundButton: true,
      type: 'success',
      center: true
    }).then(() => {

    }).catch(() => {
      //FIXME: Should not be here!
    })
    .finally(() => {
      // Delay a bit to remove listener
      setTimeout(() => {
        document.body.removeEventListener('touchstart', this.soundStarter, false);
        document.body.removeEventListener('mousedown', this.soundStarter, false);
      }, 100);

      // Sync/refresh order list for the first time.
      this.refreshList();
    });
  },

  methods: {
    onOrderSelected(order) {
      this.selectedOrder = order;
      this.selectedOrderId = parseInt(order.id);//WARNING: For some reason order.id resolved from Vuefire is a string...
    },

    toggleToolbar() {
      this.toolbar.show = !this.toolbar.show;
    },
    
    //NOTE: about settings.
    openSettings() {
      this.shop.settings.durationBefore = this.shop.settings.duration;
      this.settingsDialog.show = true
      // console.log('DOC', this.shop);
    },
    commitSettings() {
      console.log('[QC-POS] commit new settings', this.shop);
      //TODO: if duration setting has been changed, refresh the list.
      if (this.shop.settings.duration !== this.shop.settings.durationBefore) {
        this.shop.settings.durationBefore = this.shop.settings.duration;
        this.refreshList();
      }

      // Reset the reminder, since it might have be altered.
      // this.enableReminder();

      // Commit changes to Firestore.
      fsdb.collection('shops').doc(`${this.shopId}`)
      .set({
        "settings": {
          "sort": this.shop.settings.sort || 'take_meal_time:asc',
          "duration": this.shop.settings.duration || 0,
          "soundEnabled": this.shop.settings.soundEnabled || true,
          "reminder": this.shop.settings.reminder || 300000
        }
      })
      .then(() => {})
      .catch(err => {console.error(`Cannot write settings to Firestore`, err);});
    },

    logout() {
      this.$confirm('確定要離開嗎？', '登出', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        this.$store.dispatch('qcposLogout');
        setTimeout(() => {
          this.$router.push('/qcpos/login');
        }, 300);
      })
      .catch(() => {})
    },

    soundStarter() {//WARNING: Do make sound work in Safari, we have to do some workaround in here.
      if (!chime)
        chime = new Audio(`${process.env.BASE_URL}sound/chime.mp3`);
      chime.play();
      chime.pause();
      chime.currentTime = 0;
      // Remove this listener sometimes later.
      document.body.removeEventListener('touchstart', this.soundStarter, false);
    },
    playNotifySound() {
      chime.play();
    },

    enableReminder() {
      if (this.shop.settings.reminder && this.shop.settings.reminder <= 0) return;

      let ms = this.shop.settings.reminder > 0? this.shop.settings.reminder: 300000;
      this.reminder.interval = setInterval(() => {
        if (!this.orders.length) return;

        let pending_count = 0;
        this.orders.forEach(o => {
          if (!o.read || ['cancelled', 'rejected', 'accepted', 'done', 'lala_rejected'].indexOf(o.status) < 0) {
            pending_count++;
          }
        });

        if (pending_count > 0) {
          this.reminder.notification = this.$notify({
            title: '提醒',
            message: `您仍有 ${pending_count} 筆訂單尚未處理／完成。（點擊將會關閉此提醒十分鐘）`,
            type: 'warning',
            duration: ms - 100,
            onClick: () => {
              //TODO: Snooze this notification for a while (10-min in default).
              this.snoozeReminder();
            }
          });
          //TODO: PLAY SOUND AS WELL???
        }

      }, ms);
    },
    snoozeReminder(_ms) {
      if (this.reminder.notification)
        this.reminder.notification.close();
      clearInterval(this.reminder.interval);
      // Restart reminder after some time.
      setTimeout(() => {
        this.enableReminder();
      }, _ms || 600000);
    },

    //NOTE: Request for list of orders from backend, also sync with Firestore.
    refreshList() {
      this.isLoading = true;
      // Setup sync durtaion
      let from = moment().add(-this.shop.settings.duration, 'days').startOf('day').unix();
      let to = moment().endOf('day').unix();
      // Request to sync DB's list-of-orders over Firebase.
      //FIXME: Changed to secured API URL.
      axios.get(
        `${process.env.VUE_APP_APIHOST}/qcpos/firebase/sync?shopId=${this.shopId}&sort=id:desc`
        + `&from=${from}&to=${to}&includeNotes=true&includeStatus=true&timeRangeAttr=take_meal_time`
      )
      .then(response => {
        // Bind to the Firebase shop reference.
        //FIXME: Wait a bit in case that Firestore hasn't completed syncing.
        this.$bind('orders', fsdb.collection(`shops/${this.shopId}/orders`));
        this.isLoading = false;
        this.addDataListener();
      })
      .catch(err => {
        console.error('GET /qcpos/firebase/sync failed', err);
        this.isLoading = false;
      });
    },

    addDataListener() {
      this.$firestoreRefs.orders.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          //NOTE: Play chime sound when new orders arrive.
          if (change.type === 'added') {
            console.log('Data added', change.doc.data());
            if (this.shop.settings.soundEnabled) this.playNotifySound();
          }
          
          //NOTE: Update order detail for status changes.
          else if (change.type === 'modified') {
            let data = change.doc.data();
            let _id = change.doc.id;
            // console.log('Data modified', data);
            if (_id == this.selectedOrder.id && ['done', 'cancelled', 'rejected'].indexOf(data.status) >= 0) {
              console.warn('An order has been set-done, cancelled or rejected!');
              this.selectedOrder = data;//FIXME: Force re-update selected order.
            }
          }
          // else if (change.type === 'removed') console.log('Data removed', change.doc.data());
        });
      }, error => {
        console.error(`[QC-POS] addDataListener onSnapshot error`, error);
      });
    }
  },

  data() {
    return {
      shops: [],
      shopId: undefined,

      selectedOrderId: -1,
      selectedOrder: {},
      // selectedOrderIndex: -1,

      // Firestore syncing data
      shop: {
        settings: {
          // autoAcceptOrders: false,
          notification: false,
          sort: 'take_meal_time:asc',
          duration: 0, durationBefore: 0,
          soundEnabled: true,
          reminder: 300000
        }
      },
      orders: [],
      isLoading: false,

      reminder: {
        interval: undefined,
        notification: undefined
      },

      toolbar: {
        show: false
      },

      settingsDialog: {
        show: false,
        sortOptions: [
          {label: '取餐時間（最早到最晚）', value: 'take_meal_time:asc'},
          {label: '取餐時間（最晚到最早）', value: 'take_meal_time:desc'},
          {label: '流水號（升序）', value: 'order_number:asc'},
          {label: '流水號（降序）', value: 'order_number:desc'},
          {label: '金額（升序）', value: 'amount:asc'},
          {label: '金額（降序）', value: 'amount:desc'}
        ],
        durationOptions: [
          {label: '僅今天', value: 0},
          {label: '含昨天', value: 1},
          {label: '含過去兩天', value: 2}
        ],
        reminderOptions: [
          {label: '5分鐘', value: 300000},
          {label: '10分鐘', value: 600000},
          {label: '15分鐘', value: 900000},
          {label: '30分鐘', value: 1800000},
          {label: '一小時', value: 3600000}
        ]
      },
      search: {
        keyword: ''
      },

      isPub: false,
      // logoPath: `${process.env.BASE_URL}img/qcpos-logo.png`
      logoPath: `${process.env.BASE_URL}${process.env.VUE_APP_POSLOGO}`
    }
  },

  computed: {
    user() {
      return this.$store.getters.qcpos;
    }
  },

  watch: {

    // shopId: {
    //   immediate: false,
    //   handler(id) {
    //     if (id >= 0) {
    //       console.warn(`Firestore: will bind to shops/${id}...`);

    //       //1. Bind shop settings
    //       this.$bind('shop', fsdb.collection(`shops`).doc(`${id}`))
    //       .then(data => {
    //         //2. Bind orders
    //         this.refreshList();
    //       });
          
    //     }
    //   }
    // }
  }
}
</script>

<style scoped>
html, body {
  height: 100vh;
}

.qcpos-toolbar {
  background: white;
  /* box-shadow: 0 -1px 16px rgba(0, 0, 0, 0.4); */
  /* color: dimgray; */

  /* width: 33%; */
  /* height: 10%; */
  min-height: 64px;
  /* active-text-color: "#ffd04b"; */
}

.div-master {
  padding: 8px 0 48px 0;
  box-shadow: -1px 0 6px rgba(0, 0, 0, 0.25);
}
.div-detail {
  padding: 0 0 48px 0;
}

img {
  max-width: 100%;
  max-height: 100%;
}

.nav-pills .nav-link.active {
  background-color: lightgrey;
  color: dimgray;
}
</style>

<style>
.el-drawer.ttb {
  height: auto !important;
}
</style>